import { render, staticRenderFns } from "./accommodationOrders.vue?vue&type=template&id=566e408e"
import script from "./accommodationOrders.vue?vue&type=script&lang=js"
export * from "./accommodationOrders.vue?vue&type=script&lang=js"
import style0 from "./accommodationOrders.vue?vue&type=style&index=0&id=566e408e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports